import { useSelector } from 'react-redux';
import {
  selectOpen,
  openRight,
  close,
} from 'redux/reducers/sidebarsReducer';
import { store } from 'redux/store';

export default function useRightCollapse() {
  const collapsed = useSelector(selectOpen) !== 'right';

  const setCollapsed = (newCollapsed) => {
    if (!newCollapsed) {
      store.dispatch(openRight());
    } else {
      store.dispatch(close());
    }
  };

  return [collapsed, setCollapsed];
}
